const MODULE_NAME = "sinvoiceGoodsStore";

const getModuleState = (store) => {
  if (!store || !store.state || !store.state[MODULE_NAME]) return null;
  return store.state[MODULE_NAME];
};

export const getSinvoiceGoodsList = (store) => {
  const state = getModuleState(store);
  return state && Array.isArray(state.list) ? [...state.list] : [];
};

export const getSinvoiceGoodsInvoiceTemplateItems = (store) => {
  const getters = store && store.getters ? store.getters : {};
  const value = getters[`${MODULE_NAME}/invoiceTemplateItems`];
  return Array.isArray(value) ? [...value] : [];
};

export default {
  computed: {
    sinvoiceGoodsItems() {
      const getters = this.$store && this.$store.getters ? this.$store.getters : {};
      return getters[`${MODULE_NAME}/list`] || [];
    },
    sinvoiceGoodsTotal() {
      const getters = this.$store && this.$store.getters ? this.$store.getters : {};
      return Number(getters[`${MODULE_NAME}/totalElements`]) || 0;
    },
    sinvoiceGoodsLoading() {
      const getters = this.$store && this.$store.getters ? this.$store.getters : {};
      return !!getters[`${MODULE_NAME}/loading`];
    },
    sinvoiceGoodsTemplateItems() {
      return getSinvoiceGoodsInvoiceTemplateItems(this.$store);
    },
  },
  methods: {
    searchSinvoiceGoodsItems(query) {
      return this.$store.dispatch(`${MODULE_NAME}/searchGoodsItems`, query);
    },
    ensureSinvoiceGoodsTemplateItems() {
      return this.$store.dispatch(`${MODULE_NAME}/ensureGoodsTemplateItems`);
    },
    loadAllSinvoiceGoodsTemplateItems() {
      return this.$store.dispatch(`${MODULE_NAME}/loadAllGoodsTemplateItems`);
    },
    getSinvoiceGoodsItemDetail(id) {
      return this.$store.dispatch(`${MODULE_NAME}/getGoodsItemDetail`, id);
    },
    createSinvoiceGoodsItem(payload) {
      return this.$store.dispatch(`${MODULE_NAME}/createGoodsItem`, payload);
    },
    updateSinvoiceGoodsItem(id, payload) {
      return this.$store.dispatch(`${MODULE_NAME}/updateGoodsItem`, { id, payload });
    },
    deleteSinvoiceGoodsItem(id) {
      return this.$store.dispatch(`${MODULE_NAME}/deleteGoodsItem`, id);
    },
    getSinvoiceGoodsList() {
      return getSinvoiceGoodsList(this.$store);
    },
    getSinvoiceGoodsTemplateItems() {
      return getSinvoiceGoodsInvoiceTemplateItems(this.$store);
    },
  },
};

